import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FilterService } from 'primeng/api';
import { DATE_RANGE_PRESETS, getDateRangePreset, matchesDateRange } from '../../utils/date-range-filter.utils';

@Component({
    selector: 'app-date-range-column-filter',
    standalone: false,
    templateUrl: './date-range-column-filter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: { style: 'display: contents' }
})
export class DateRangeColumnFilterComponent {
    @Input({ required: true }) field!: string;

    readonly presets = DATE_RANGE_PRESETS;
    readonly getPreset = getDateRangePreset;

    constructor(filterService: FilterService) {
        filterService.register('dateRange', matchesDateRange);
    }
}